import script from "./AddInvestmentPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddInvestmentPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddInvestmentPage.vue?vue&type=style&index=0&id=04e410db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e410db"]])

export default __exports__